// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_BuscaestadosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for buscaEstados() /localidades/buscaEstados
 *
 * Proxy to locations-service (Go microservice). Each row mirrors
 * `entity.State` from services/locations-service/src/localidades/state/entity/entity.go.
 */
import type { Localidades_BuscaestadosRow } from './Localidades_BuscaestadosRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Localidades_BuscaestadosResponseDados = Localidades_BuscaestadosRow[];

export type Localidades_BuscaestadosResponse = ApiResponse<Localidades_BuscaestadosResponseDados>;

registerResponseContract('Localidades_BuscaestadosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:        { type: 'number',  required: false },
      Name:      { type: 'string',  required: false },
      UF:        { type: 'string',  required: false },
      CountryID: { type: 'number',  required: false },
      Cities: {
        type: 'array',
        required: false,
        items: {
          ID:      { type: 'number',  required: false },
          Name:    { type: 'string',  required: false },
          StateID: { type: 'number',  required: false },
        },
      },
    },
  },
})
